import { useLiffToken } from "@/app/store"
import axios from "axios"

axios.interceptors.request.use(
    config => {
        if (config.url.startsWith('/api')) {
            const liffToken = useLiffToken.getState()?.token
            config.headers['x-line-token'] = liffToken
        }
        return config
    }
)